export var ADDITIONAL_INFO_MAX_LENGTH = 255;
export var ADDITIONAL_INFO_SERIALIZATION_FAILED = '{"additionalInfoError":"SERIALIZATION_FAILED"}';
export var ADDITIONAL_INFO_LIMIT_EXCEEDED = '{"additionalInfoError":"LIMIT_EXCEEDED"}';
export var stringifyJsonSafely = function (value) {
    try {
        var serialized = JSON.stringify(value);
        return typeof serialized === "string" ? serialized : null;
    }
    catch (_error) {
        return null;
    }
};
export var getSerializedJsonLength = function (value) {
    var serialized = stringifyJsonSafely(value);
    return serialized === null ? null : serialized.length;
};
var copyPayload = function (payload) {
    var copy = {};
    Object.keys(payload).forEach(function (field) {
        copy[field] = payload[field];
    });
    return copy;
};
/**
 * Removes all supplied top-level fields as one reduction step.
 */
export var omitAdditionalInfoFields = function () {
    var fields = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fields[_i] = arguments[_i];
    }
    return function (payload) {
        var reduced = copyPayload(payload);
        fields.forEach(function (field) { return delete reduced[field]; });
        return reduced;
    };
};
/**
 * Shortens a top-level text field without splitting Unicode surrogate pairs.
 * The longest prefix whose completed JSON fits the limit is retained.
 */
export var shortenAdditionalInfoText = function (field) {
    return function (payload, maxLength) {
        var value = payload[field];
        if (typeof value !== "string") {
            return payload;
        }
        var reduced = copyPayload(payload);
        var characters = Array.from(value);
        var shortest = 0;
        var longest = characters.length;
        var fittingLength = 0;
        reduced[field] = "";
        var emptyLength = getSerializedJsonLength(reduced);
        if (emptyLength === null || emptyLength > maxLength) {
            return reduced;
        }
        while (shortest <= longest) {
            var candidateLength = Math.floor((shortest + longest) / 2);
            reduced[field] = characters.slice(0, candidateLength).join("");
            var serializedLength = getSerializedJsonLength(reduced);
            if (serializedLength !== null && serializedLength <= maxLength) {
                fittingLength = candidateLength;
                shortest = candidateLength + 1;
            }
            else {
                longest = candidateLength - 1;
            }
        }
        reduced[field] = characters.slice(0, fittingLength).join("");
        return reduced;
    };
};
/**
 * Removes trailing entries until the completed JSON fits or the minimum array length is reached.
 */
export var removeAdditionalInfoArrayTail = function (field, minimumLength) {
    if (minimumLength === void 0) { minimumLength = 0; }
    return function (payload, maxLength) {
        var value = payload[field];
        if (!Array.isArray(value)) {
            return payload;
        }
        var reduced = copyPayload(payload);
        var reducedArray = value.slice();
        reduced[field] = reducedArray;
        while (reducedArray.length > Math.max(0, minimumLength)) {
            var serializedLength = getSerializedJsonLength(reduced);
            if (serializedLength !== null && serializedLength <= maxLength) {
                break;
            }
            reducedArray.pop();
        }
        return reduced;
    };
};
/**
 * Serializes additional-info JSON and applies reductions in their declared order.
 * Serialization and reduction failures are converted to stable marker payloads.
 */
export var serializeAdditionalInfo = function (payload, reductions) {
    if (reductions === void 0) { reductions = []; }
    var currentPayload = payload;
    var serialized = stringifyJsonSafely(currentPayload);
    if (serialized === null) {
        return ADDITIONAL_INFO_SERIALIZATION_FAILED;
    }
    if (serialized.length <= ADDITIONAL_INFO_MAX_LENGTH) {
        return serialized;
    }
    try {
        for (var _i = 0, reductions_1 = reductions; _i < reductions_1.length; _i++) {
            var reduction = reductions_1[_i];
            currentPayload = reduction(currentPayload, ADDITIONAL_INFO_MAX_LENGTH);
            serialized = stringifyJsonSafely(currentPayload);
            if (serialized === null) {
                return ADDITIONAL_INFO_SERIALIZATION_FAILED;
            }
            if (serialized.length <= ADDITIONAL_INFO_MAX_LENGTH) {
                return serialized;
            }
        }
    }
    catch (_error) {
        return ADDITIONAL_INFO_SERIALIZATION_FAILED;
    }
    return ADDITIONAL_INFO_LIMIT_EXCEEDED;
};
